import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { LoaderService } from '@teem/services/loader.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateStoreModalComponent } from '@teem/features/dashboard/modals/create-store-modal/create-store-modal.component';
import { data } from 'jquery';

declare var $;

@Component({
    selector: 'app-step',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss']
})
export class StepComponent implements OnInit, AfterViewInit {

    constructor(
		private dashboardService: DashboardService,
        private loaderService: LoaderService,
        private modalService : NgbModal
    ) {

    }
    @Input() cards: any[] = [];
    @Input() percentage: any = 0;



    showMore = false;
    showSteps = false;
    showAllSteps = true;

    // cards = [
    //     { title: 'Business info', description: 'Add information about your address, VAT number, etc', required: true, complete: true, skipped: false, current: false },
    //     { title: 'Client info', description: 'Add at least one client to your account', required: false, complete: false, skipped: true, current: false },
    //     { title: 'Set up payment options', description: 'Choose payment methods you would like to activate', required: true, complete: false, skipped: false, current: true },
    //     { title: 'Create first invoice', description: 'Create your first invoice using Teem app', required: false, complete: false, skipped: false, current: false },
    //     { title: 'Send first invoice', description: 'Send your first invoice to the client', required: false, complete: false, skipped: false, current: false },
    //     { title: 'Receive first payment', description: 'Receive first payment with Teem app', required: false, complete: false, skipped: false, current: false },
    //     { title: 'Invite team members', description: 'Invite your staff to power up growth together', required: false, complete: false, skipped: false, current: false },
    // ];
    ngOnInit(): void {

    }
    ngAfterViewInit(): void {

    }

    toggleCards(property: 'showSteps' | 'showMore'): void {
        this[property] = !this[property];
    }

    skipCard(card: any) {
        console.log(card)
		this.loaderService.startLoading();

        card.skipped = true;


        const payload = {
			title: card['title']
		};
		this.dashboardService.skipCardData(payload).subscribe((response: any = []) => {
            console.log(response);
            this.showAllSteps = response.hideCardsSection;
			this.loaderService.stopLoading();
		});


        // this.dashboardService.skipCardData().subscribe((response: any = []) => {
			
		// });

    }

    get visibleCards() {
        return this.showMore ? this.cards : this.cards.slice(0, 4);
    }

    redirectToUrl(card: any) {
        if (card?.url) {
            window.location.href = card.url;
        }
    }

    openStoreModal() {
        const modalRef = this.modalService.open(CreateStoreModalComponent);
    }
}